import axios from "axios";

const BASE_URL_ENV = process.env.REACT_APP_API_KEY;

const axiosInstance = axios.create({
  // baseURL: "https://capapi.digitizeict.com/api/users/",
  baseURL: `${BASE_URL_ENV}users/`,
});

export default axiosInstance;
